import { logError } from '@booking/utils/logger.ts'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (error, _instance, _info) => {
    logError(error)
  }
})
